//
// Copyright (c) 2024 Emplifi, Inc.
//

define([
  "backbone",
  "i18n/i18n",
  "marionette",
  "messaging/messenger",
  "./apiKeyListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/apiKeyAdmin/apiKeyModel",
], function (Backbone, i18next, Marionette, Messenger, ApiKeyListView, SortableListModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "apiKeyList";
      this.region = options.region;
      this.namespace = options.namespace;
      this.tenant = options.tenant;
      this._setUpVents();
    },
    show: function () {
      const headers = Messenger.reqres.request("apiKey:list:headers");

      Messenger.onSave(function () {
        Messenger.saveAttempted(true);
      }, this);

      const extendedEvents = {
        "click .deleteApiKey": function () {
          const model = this.model;
          Messenger.yesNoDialog(
            i18next.t("apiKey.confirmDeleteApiKey", { name: model.get("name") }),
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete API Key",
                  id: model.id,
                  idType: "API Key",
                  object: "API Key",
                  source: "API Keys List",
                });
                model.deleteModel();
              },
            },
            this,
          );
        },
        "click .copyApiKey": function () {
          const model = this.model;
          try {
            Messenger.vent.trigger("track:interaction", {
              action: "Copy API Key",
              id: model.id,
              idType: "API Key",
              object: "API Key",
              source: "API Keys List",
            });
            navigator.clipboard
              .writeText(model.get("value"))
              .then(() => Messenger.okDialog(i18next.t("apiKey.copySuccess")))
              .catch((e) => {
                console.error("Failed to copy API Key to clipboard", e);
                Messenger.okDialog(i18next.t("apiKey.copyFailedError"));
              });
          } catch (e) {
            console.error("Failed to copy API Key to clipboard", e);
            Messenger.okDialog(i18next.t("apiKey.copyFailedError"));
          }
        },
        "click .revokeApiKey": function () {
          const model = this.model;
          Messenger.yesNoDialog(
            i18next.t("apiKey.confirmRevokeApiKey", { name: model.get("name") }),
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Revoke API Key",
                  id: model.id,
                  idType: "API Key",
                  object: "API Key",
                  source: "API Keys List",
                });
                model.revokeApiKey().then();
              },
            },
            this,
          );
        },
      };

      this.apiKeys = Messenger.reqres.request("tenant:apiKeys", {
        tenantId: this.tenant.id,
      });
      this.layout = new ApiKeyListView.apiKeyListLayout();
      this.apiKeyList = this.addSubModule(
        new SortableListModule({
          region: this.layout.apiKeyList,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.namespace,
          extendedEvents: extendedEvents,
        }),
      );
      this.layout.on("show", this._showSubViews, this);
      this.layout.on("add:apiKey", this._onAddApiKey, this);
      this.showRegion(this.layout);
    },
    _onAddApiKey: function () {
      this.apiKeys.onSynced(() => {
        const apiKey = this.apiKeys.addApiKey();
        Messenger.vent.trigger("show:tenant:profile:apiKey", { apiKey: apiKey });
      }, this);
    },
    _onShowApiKeys: function () {
      this.show();
      Backbone.history.navigate("accountAdmin/tenants/" + this.tenant.id + "/apiKeys");
    },
    _showSubViews: function () {
      this.apiKeys.onSynced(() => this.apiKeyList.show(this.apiKeys));
    },
    _setUpVents: function () {
      Messenger.vent.on("show:tenant:profile:apiKeys", this._onShowApiKeys, this);
      //a row was selected in the sortable list (prepend namespace)
      Messenger.vent.on(
        this.namespace + ":selected:row",
        function (model) {
          Messenger.vent.trigger("show:tenant:profile:apiKey", { apiKey: model });
        },
        this,
      );
    },
  });
});
